import { HttpContextToken } from '@angular/common/http';

// Opt-out token for the default-on error-message interceptor; `false` means the interceptor runs.
export const SKIP_ERROR_MESSAGE = new HttpContextToken<boolean>(() => false);
